import onDocumentLoaded from "../lib/onDocumentLoaded";
import debounce from '../lib/debouncer';

export default function init() {
	onDocumentLoaded(() => {
		//https://css-tricks.com/a-lightweight-masonry-solution/
		const gridRoots = [...document.querySelectorAll(".wp-block-post-template.style-grid-modifier-masonry, .testimonial-listing")];
		
		// Firefox is the only browser that currently supports CSS masonry, but "masonry-auto-flow: next;" isn't working
		//const browserSupportsCSSMasonry = getComputedStyle(grids[0]).gridTemplateRows === 'masonry';
		
		if (gridRoots.length) {
			const grids = gridRoots.map(grid => ({
				_el: grid,
				gap: parseFloat(getComputedStyle(grid).rowGap),
				items: [...grid.children].filter(c => c instanceof HTMLElement).filter(c => +getComputedStyle(c).gridColumnEnd !== -1),
				ncol: 0,
				mod: 0
			}));

			function setCurrentColumnCount(el: Element, cols: number) {
				el.setAttribute('data-current-columns', cols.toString());
			}

			function waitForImages(grid: { _el: Element; items: HTMLElement[]; }) {
				return Promise.all(
					[...grid._el.querySelectorAll('img')].map(img => {
						if (img.complete) return Promise.resolve();
						return new Promise(resolve => img.addEventListener('load', resolve, { once: true }));
					})
				);
			}

			function layout() {
				grids.forEach(grid => {
					waitForImages(grid).then(() => {
						/* get the post relayout number of columns */
						let ncol = getComputedStyle(grid._el).gridTemplateColumns.split(' ').length;
						setCurrentColumnCount(grid._el, ncol);
						
						grid.items.forEach(c => {
							const new_h = c.getBoundingClientRect().height;
							
							if (new_h !== parseInt(c.dataset.h ?? '0')) {
								c.dataset.h = new_h.toString();
								grid.mod++
							}
						});
						
						/* if the number of columns has changed */
						if (grid.ncol !== ncol || grid.mod) {
							/* update number of columns */
							grid.ncol = ncol;
							setCurrentColumnCount(grid._el, ncol);

							//if (!browserSupportsCSSMasonry) {
							/* revert to initial positioning, no margin */
							grid.items.forEach(c => c.style.removeProperty('margin-top'));
			
							/* if we have more than one column */
							if (grid.ncol > 1) {
								grid.items.slice(ncol).forEach((c, i) => {
									let prev_fin = grid.items[i].getBoundingClientRect().bottom /* bottom edge of item above */,
										curr_ini = c.getBoundingClientRect().top /* top edge of current item */;
									
									c.style.marginTop = `${prev_fin + grid.gap - curr_ini}px`
								})
							}
							//}
							
							grid.mod = 0
						}
					});
				})
			}

			//addEventListener('load', e => {
				layout(); /* initial load */
				window.addEventListener('resize', debounce(layout));
			//}, false);
		}
	}, false);
}